export default {
  login: {
    signInTitle: 'Sign in to Arduino',
    signInTitleJunior: 'Sign in with a Junior account',
    usernameLabel: 'Username or Email',
    childUsernameLabel: 'Username',
    passwordLabel: 'Password',
    fieldRequired: 'Field required',
    forgotPassword: 'Forgot your password?',
    signIn: 'Sign in',
    noAccount: 'Don’t have an account yet?',
    createAccount: 'Create one.',
    socialTitle: 'Or sign in with',
    access_denied: "Can't log in at the moment, please retry refreshing the page",
    invalid_user_password: 'Wrong email/username or password',
    too_many_attempts: 'Too many login attempts, retry later',
    asJunior: 'Junior Account',
    asAdult: 'Adult Account',
    childAttemptDesc: 'Looks like you are trying to access an Arduino Education platform.\n Sign in below to do so.',
    apiError: 'Encountered an error while reaching our services, please refresh the page and retry later',
    dialogReminderBody:
      'We sent an email with instructions to your parent’s email <1>{{parentEmail}}</1>. You will be able to sign in once they finalize your account.',
    dialogAction: 'Got it',
    loginHere: 'SIGN IN HERE',
    regularLoginAttempt: 'You might have a adult account instead.',
    childLoginAttempt: 'Looks like you have Junior credentials, so we redirected you to the Junior Sign in.',
    teenConfirmation: 'To finalize a Junior account you have to first sign in yourself as an adult.',
    finalizeChild:
      'To finish setting up your child’s account you have to first sign in yourself as an adult.\nUse the Arduino account associated with {{finalizeEmail}} or create a new one.',
    unconfirmed_teen: 'Your parent must confirm your account before you can log in',
    unconfirmed_child: 'Your parent must confirm your account before you can log in',
    banners: {
      education:
        'Welcome to Arduino Education! To get started, sign in to your existing Arduino account or create a new one.',
    },
    registeredAsStudent: 'Registered as Student before?',
    welcomeTitle: 'Welcome to Arduino',
    welcomeSubTitle: 'Learn and create, with the ever-growing platform',
    juniorBannerTitle: 'Hey Kids!',
    juniorBannerSubtitle: 'To sign in, click here if you are under 14',
    carousel: {
      discover: 'Discover More',
      dashboard: {
        title: 'Create beautiful dashboards with Arduino Cloud',
        subTitle:
          'Mix and match customizable widgets to visualize real time or historical data, or control your devices.',
      },
      device: {
        title: 'Connect smart devices in minutes with Arduino cloud',
        subTitle: 'Choose from a wide range of compatible devices to connect, we will take care of the necessary code.',
      },
      project: {
        title: 'Control projects from anywhere in the world with Arduino Cloud',
        subTitle:
          'Control your project from any device, share it with others, automate it, or control with voice using Alexa™.',
      },
    },
  },
  recover: {
    title: 'Recover your account',
    description: 'Enter the email address associated with your account below.',
    childDescription: 'Enter your username and the parent’s email associated with your account below.',
    username: 'Your username',
    emailLabel: 'Insert your email',
    emailAdultLabel: "Adult's email",
    fieldRequired: 'Field required',
    submitText: 'Recover',
    orSignin: 'Or <1>sign in</1> instead',
    signIn: 'Sign in',
    emailInvalid: 'Must be a valid email',
    emailSent: 'Check your email, we just sent you a link to complete the reset of your password.',
    yourUsername: 'Your Username',
    tooltip:
      'The username is the word you used to sign in to your account. If you do not remember your username, ask your parent to restore your account from their Arduino profile page.',
    emailSentToParent: 'Ask your parent to check their email inbox to reset your account’s password.',
    childError: 'This is not the correct email, try again or ask your parent.',
    parentEmailLabel: 'Your parent’s email',
    childTooltip:
      'If you don’t remember your username, ask your parent to check it on their Arduino profile, where they can also add a new password for you.',
  },
  register: {
    title: 'Sign up to Arduino',
    birthDescription:
      'Enter your birth date below to continue and ensure the data is correct: it will determine the type of account created for you.',
    birthDate: 'Birthday',
    email: 'Enter your email',
    next: 'Next',
    username: 'Choose a username',
    password: 'Choose a password',
    confirmPassword: 'Confirm password',
    submitText: 'Sign up',
    privacy: 'I have read the <1>Privacy Policy</1> and accept the <3>Terms of Service</3>',
    privacyMd:
      'I have read the [Privacy Policy](https://www.arduino.cc/PrivacyPolicy/) and accept the [Terms of Service](https://www.arduino.cc/en/Main/TermsOfService)',
    newsletter: 'I would like to receive the Arduino newsletter.',
    marketing: {
      approval: 'I would like to get email updates about special deals and commercial offers from Arduino.',
      everything: 'Everything',
      maker: 'Maker',
      education: 'Education',
      professional: 'Professional',
      atLeastOneChoice: 'Please select at least one marketing category',
    },
    tracking:
      'I agree to see personalised commercial offers from Arduino based on my browsing and purchasing behaviour.',
    fieldRequired: 'Field required',
    usernameInvalid: 'Username invalid',
    emailInvalid: 'Must be a valid email',
    passwordMinLength: 'Minimum 8 characters long',
    passwordMismatch: 'Password mismatch',
    user_exists: 'Username or Email already exist',
    LegacyInvite: 'Please accept the invite you received via e-mail',
    blockTitle: 'We are unable to create an account',
    blockDescription: 'You are ineligible to create an Arduino account.',
    blockButton: 'Go back to arduino',
    tooltip:
      'Only letters, numbers, hypen (-) and underscore (_) are allowed. Your username must start with a letter or number and be at least 3 characters long.',
  },
  reset: {
    title: 'Choose new password',
    description: 'Insert a new password in the field below to reset it.',
    password: 'New password',
    confirmPassword: 'Confirm new password',
    passwordMinLength: 'Minimum 8 characters long',
    passwordMismatch: 'Password mismatch',
    fieldRequired: 'Field required',
    submitText: 'Reset password',
    success: 'Your password was successfully updated.',
    LegacyInvite: 'Please accept the invite you received via e-mail',
  },
  footer: {
    terms: 'Terms of Service',
    privacy: 'Privacy',
    security: 'Security',
  },
  registerChild: {
    title: 'Create a junior account',
    description: 'To create an account, choose your avatar image, username and password.',
    modalTitle: 'Choose an avatar',
    username: 'Username',
    usernameInvalid: 'Username invalid',
    fieldRequired: 'Field required',
    passwordMinLength: 'Minimum 8 characters long',
    password: 'Choose a password',
    tooltip:
      'The username is created for you automatically, but you can generate new ones until you find the best one. You will use this username to log in to Arduino, and other users will see it when you post projects.',
    submitText: 'Next',
  },
  sendParentEmail: {
    title: 'Parent email address',
    description:
      'A parent needs to help you create the account. Enter their email address below and we will send instructions on how to proceed.',
    email: 'Parent’s email address',
    fieldRequired: 'Field required',
    emailInvalid: 'Must be a valid email',
    submitText: 'Send email',
    error: 'Cannot create an account at the moment, please retry later',
    noUserEmail: 'The email cannot be the one prompted before',
    confirmEmail: 'Confirm email address',
    emailMismatch: 'Parent email and confirmation do not match',
  },
  twofactor: {
    code: 'Enter Code',
    save_browser: "Don't ask again on this device",
    title: '2-Step Verification',
    otp_subtitle: 'authenticator app',
    otp_description:
      'This extra step shows that it’s really you trying to sign in, get a verification code from the Authenticator app',
    fieldRequired: 'Field Required',
    otp_digit: 'Must be 6 digits',
    verify: 'Verify',
    another_way: 'Try another way',
    timeout: 'Transaction timeout, please <1>refresh</1> the page',
    select_method_title: 'Try another way to sign in',
    otp_method: 'Get a verification code on your smartphone with the <1>Authenticator app</1>',
    recovery_method: 'Enter your <1>Recovery Code</1>',
    recovery_subtitle: 'recovery code',
    recovery_description: 'Sign in without a device by entering the recovery code.',
    enter_recovery: 'Enter Recovery Code',
    new_recovery_title: 'Here’s your new Recovery Code',
    new_recovery_description:
      'The recovery code is for single-use only.\n The new code below replaces the one you just used. Please, keep it somewhere safe.',
    continue: 'Continue',
    saved_recovery: 'I have safely recorded this code',
    recovery_required: 'Please confirm you recorded the code.',
    change_account: 'Having troubles signing in? <1>Change account</1>',
    use_recovery: 'Use recovery code',
    use_authenticator: 'Use authenticator',
    new_recovery: 'New recovery',
    download_recovery: 'Download code',
  },
};
